//
// extend core typewise collations
//
var collation = require('typewise-core/collation')

// TODO: set, map

module.exports = collation



//////////////////
// WEBPACK FOOTER
// ./node_modules/typewise/collation.js
// module id = /Cfs
// module chunks = 70